import { Box } from '@mui/material';
import { MainLeasingCalc } from 'features/main-leasing-calc';
import { MainSelectionCalc } from 'features/main-selection-calc';
import { useParams } from 'react-router-dom';
import { checkIfAdmin } from 'shared/api';
import { DashboardHeaderBackLink } from 'widgets/dashboard-header-back-link';
import styles from './new-application.module.scss';
import { useState, useEffect } from 'react';

async function getLink() {
  const isAdmin = await checkIfAdmin();
  return isAdmin ? '/dashboard/admin/last' : '/dashboard/last';
}

export const NewApplication = () => {
  const { type } = useParams();
  const title =
    type == 'select' ? 'Новая заявка на подбор транспортного средства' : 'Новая заявка на лизинг';

  const calcBLock = () => {
    if (type == 'select') {
      return <MainSelectionCalc title={'Оставьте заявку на подбор ТС'} isDashboard={true} />;
    }
    if (type == 'leasing') {
      return <MainLeasingCalc title={'Оставьте заявку на лизинг'} isDashboard={true} />;
    }
  };

  const [link, setLink] = useState('/dashboard/last');

  useEffect(() => {
    getLink().then((link) => {
      setLink(link);
    });
  }, [window.location.href]);

  return (
    <Box className={styles.newAppCalc}>
      <DashboardHeaderBackLink link={link} title={title} />
      <Box className={styles.calcBox}>{calcBLock()}</Box>
    </Box>
  );
};
